<template>
  <div class="first-step-box">
    <div class="form first-form" v-if="stepCopy == 1">
      <div class="form-item">
        <!--请选择主链或协议， 以及对应的管理费-->
        <p class="label required-fields">{{ $t('8000126') }}</p>
        <div class="value select-value" :class="{errorClass: !!errorRulesMsg1,'empty-value': !firstTemp.protocol}"
             @click="chainPopup = true;errorRulesMsg2 = ''">
          {{ firstTemp.protocol ? `${protocolDetail.protocol} ${protocolDetail.upFee}ET` : $t('10000009') }}
          <i class="iconfont" :class="chainPopup ? 'icon-shangla' : 'icon-xiala'"></i>
        </div>
        <span class="error-msg-style">{{ errorRulesMsg1 }}</span>
      </div>
      <div class="form-item">
        <!--请输入合约地址/Ticker-->
        <p class="label required-fields">{{ $t('8000128') }}</p>
        <van-field type="textarea" rows="1" autosize :class="{errorClass: !!errorRulesMsg2}" class="value" @input="handleInput" @blur="handleBlur"
                   @focus="handleFocus" v-model="firstTemp.currencyAddress" clearable :placeholder="$t('8000138')"/>
        <span class="error-msg-style">{{ errorRulesMsg2 }}</span>
      </div>
    </div>
    <div class="confirm-information" v-if="stepCopy == 2">
      <!--请确认以下信息：-->
      <h2 class="bold title">{{ $t('8000116') }}</h2>
      <ul v-show="!resultData.data.existFlag && firstTemp.protocol == 'SOLANA'">
        <!--发行总量-->
        <li>· {{ $t('10000010') }}：{{ resultData.data.totalIssueAmount == '' || resultData.data.totalIssueAmount == 0 ? '--' : toThousands(resultData.data.totalIssueAmount) }}</li>
        <!--币种数量的小数位长度-->
        <li>· {{ $t('8000117') }}：{{ resultData.data.currencyDigit || 0 }}</li>
      </ul>
      <ul v-show="!resultData.data.existFlag && firstTemp.protocol == 'ARC20'">
        <!--币种简称-->
        <li>· {{ $t('8000068') }}：{{ resultData.data.currency || '--' }}</li>
        <!--币种全称-->
        <li>· {{ $t('8000119') }}：{{ resultData.data.currencyFull || '--' }}</li>
        <!--币种数量的小数位长度-->
        <li>· {{ $t('8000117') }}：{{ resultData.data.currencyDigit || 0 }}</li>
      </ul>
      <ul v-show="!resultData.data.existFlag && firstTemp.protocol != 'SOLANA' && firstTemp.protocol != 'ARC20'">
        <!--币种简称-->
        <li>· {{ $t('8000068') }}：{{ resultData.data.currency || '--' }}</li>
        <!--币种全称-->
        <li>· {{ $t('8000119') }}：{{ resultData.data.currencyFull || '--' }}</li>
        <!--币种数量的小数位长度-->
        <li>· {{ $t('8000117') }}：{{ resultData.data.currencyDigit || 0 }}</li>
        <!--发行总量-->
        <li>· {{ $t('10000010') }}：{{ resultData.data.totalIssueAmount == '' || resultData.data.totalIssueAmount == 0 ? '--' : toThousands(resultData.data.totalIssueAmount) }}
        </li>
      </ul>
      <ul v-show="resultData.data.existFlag">
        <!--币种简称-->
        <li>· {{ $t('8000068') }}：{{ resultData.data.currency || '--' }}</li>
        <!--币种全称-->
        <li>· {{ $t('8000119') }}：{{ resultData.data.currencyFull || '--' }}</li>
        <!--发行总量-->
        <li>· {{ $t('10000010') }}：{{ resultData.data.totalIssueAmount == '' || resultData.data.totalIssueAmount == 0 ? '--' : toThousands(resultData.data.totalIssueAmount) }}</li>
        <!--币种数量的小数位长度-->
        <li>· {{ $t('8000117') }}：{{ resultData.data.currencyDigit || 0 }}</li>
        <!--币种價格的小数位长度-->
        <li>· {{ $t('8000120') }}：{{ resultData.data.priceTick || 0 }}</li>
        <!--区块查询-->
        <li>· {{ $t('10000011') }}：{{ resultData.data.blockchainQuery || '--' }}</li>
        <!--英文幣種簡介-->
        <li>· {{ $t('8000122') }}：{{ resultData.data.content || '--' }}</li>
      </ul>
    </div>
    <div class="form-buttons-box">
      <van-button class="back-btn" @click="handleBack">{{$t('10000012')}}</van-button>
      <van-button class="next-btn" @click="nextStep" :loading="submitButtonLoading" :disabled="buttonDisabled">{{$t('10000013')}}</van-button>
    </div>
    <van-popup v-model="chainPopup" round position="bottom" class="chain-popup">
      <van-picker
          :title="$t('10000009')"
          show-toolbar
          :confirm-button-text="$t('300287')"
          :cancel-button-text="$t('300111')"
          :columns="chainList"
          @confirm="onConfirm"
          @cancel="chainPopup = false">
        <template #option="option">
          <div class="custom-option">{{ `${option.protocol} ${option.upFee}ET` }}</div>
        </template>
      </van-picker>
    </van-popup>
    <van-popup v-model="firstStepTipsModel" class="msg-tip-popup" closeable close-icon="cross"
               close-icon-position="top-right">
      <div class="tip-message-box">
        <svg class="icon" aria-hidden="true">
          <use :xlink:href="buttonText == '8000129' ? '#icon-a-Group1171274985' : '#icon-tishi-1'"></use>
        </svg>
        <p>{{ errorLimitMsg }}</p>
        <van-button @click="handleConfirm(buttonText)">{{ $t(buttonText) }}</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {Field, Popup, Picker, Button, Toast} from "vant";
import {chainListApi, checkCurrencyAddress} from "../../../api/spot";
import {toThousands} from "../../../utils";
import {mapGetters} from "vuex";

export default {
  name: "firstStep",
  components: {
    vanField: Field,
    vanPopup: Popup,
    vanPicker: Picker,
    vanButton: Button
  },
  data() {
    return {
      firstTemp: {
        protocol: '',
        currencyAddress: ''
      },
      chainPopup: false,
      protocolDetail: null,
      chainList: [],
      isShowErrorModel: false,
      resultData: {
        data: {
          currencyId: 0,
          existFlag: true,
          closeStatus: true,
          currency: '',
          currencyFull: '',
          totalIssueAmount: 0,
          priceTick: 0,
          sizeTick: 0,
          blockchainQuery: '',
          content: ''
        }
      },
      errorTipModelMsg: '',
      errorRulesMsg1: '',
      errorRulesMsg2: '',
      stepCopy: 1,
      submitButtonLoading: false,
      confirmText: '',
      isCloseIcon: false,
      modelType: '',
      errorLimitMsg: '',
      buttonText: '',
      firstStepTipsModel: false,
    }
  },
  computed: {
    ...mapGetters(['isDirection']),
    buttonDisabled() {
      return !this.firstTemp.currencyAddress || !this.firstTemp.protocol || !!this.errorRulesMsg1 || !!this.errorRulesMsg2
    }
  },
  created() {
    // this.getChainList()
  },
  methods: {
    toThousands,
    onConfirm(value) {
      console.log(value)
      this.protocolDetail = value
      this.firstTemp.protocol = value.protocol
      this.chainPopup = false
      this.errorRulesMsg1 = ''
    },
    getChainList() {
      chainListApi().then(res => {
        this.chainList = res.data || []
      })
    },
    handleBack() {
      if (this.stepCopy == 1) {
        if (this.$parent.isApp == 1) {
          this.$jsBridge.callHandler(this.$jsBridgeCmd.goBack, {}, (data) => {
          })
        } else {
          this.$router.back()
        }
      } else {
        this.stepCopy = 1
      }
    },
    handleInput(value) {
      this.firstTemp.currencyAddress = value.replace(/[\W]/g, '')
    },
    handleBlur(event) {
      if (!this.firstTemp.protocol && event.target._value) {
        this.errorRulesMsg1 = this.$t('8000126')  // 请选择主链或协议，以及对应的管理费
        return false
      }
      if (!event.target._value) {
        this.errorRulesMsg2 = this.$t('8000128')  // 请输入合约地址/Ticker
        return false
      }
      this.getCheckCurrencyAddress()
    },
    getCheckCurrencyAddress() {
      this.submitButtonLoading = true
      checkCurrencyAddress(this.firstTemp).then(res => {
        this.submitButtonLoading = false
        this.resultData = res
        if (res.code == '604') {
          this.errorRulesMsg2 = this.$t('8000111')  // 该币种已经在SuperEx主板交易区中存在，无法再创建交易对！
        } else if (res.code == '605') {
          this.errorRulesMsg2 = this.$t('8000112')  // 请输入有效的合约地址/Ticker
        } else if (res.code == '606') {
          this.errorRulesMsg2 = this.$t('8000110')  // 该币种已被禁止上架！
        } else if (res.code == '608') {
          this.errorRulesMsg2 = this.$t('8000176')  // 目前暂不支持该币种上架！
        } else if (res.code == '602') {
          this.errorLimitMsg = this.$t('8000114') // 您今天创建新币的过程中错误输入的次数太多， 因此今天您不能再进行创建新币的申请，请明天再试。
          this.firstStepTipsModel = true
          this.buttonText = '300141'  // 好的
        } else if (res.code == '610') {
          this.errorLimitMsg = this.$t('8000192') // 抱歉，该币种的智能合约的内容或相关权限设定有较高安全风险。请尝试使用其他币种。
          this.firstStepTipsModel = true
          this.buttonText = '300141'  // 好的
        } else if (res.code == '611') {
          this.errorLimitMsg = this.$t('8000193') // 抱歉，该币种的智能合约的内容可能有潜在风险，目前无法上币。请尝试使用其他币种。
          this.firstStepTipsModel = true
          this.buttonText = '300141'  // 好的
        } else if (res.code == '603') {
          this.errorLimitMsg = this.$t('8000113', {num: this.protocolDetail.upFee}) // 您的现货主板区ET余额不足， 创建新交易对需要支付 {num} ET管理费用，请充值后再来
          this.firstStepTipsModel = true
          this.buttonText = '300222'  // 去充值
        } else if (res.code == '200') {
          if (res.data.existFlag) {
            this.errorLimitMsg = this.$t('8000115') // 该币种已存在，现在将创建您的交易对副本！
            this.firstStepTipsModel = true
            this.buttonText = '8000129'  // 确认创建
          } else {
            this.stepCopy = 2
          }
        } else {
          Toast(res.msg)
        }
      })
    },
    handleConfirm(type) {
      if (type == '300141') {
        this.firstStepTipsModel = false
      } else if (type == '300222') {
        this.firstStepTipsModel = false
        if (this.$parent.isApp == 1) {
          this.$jsBridge.callHandler(this.$jsBridgeCmd.appRecharge, {code: 200}, (data) => {
            this.firstStepTipsModel = false
          })
          return false
        } else {
          this.$router.push('/download')
          return false
        }
      } else {
        this.stepCopy = 2
        this.firstStepTipsModel = false
      }
    },
    handleFocus() {
      this.errorRulesMsg2 = ''
    },
    nextStep() {
      this.submitButtonLoading = true
      if (this.stepCopy == 1) {
        this.getCheckCurrencyAddress()
      } else {
        this.submitButtonLoading = false
        this.$emit('handleNextStep', 2)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../style/mixin";
@import "../../../assets/css/variableName";
@import "../public";

.first-step-box {
  padding: torem(16) torem(16) torem(100);

  .select-value {
    padding: torem(16);
    background: #F9F9F9;
    display: flex;
    align-items: center;
    justify-content: space-between;

    i {
      font-size: torem(12);
      color: #7F8490;
    }
  }

  .empty-value {
    color: #7F8490;
  }

  .chain-popup {
    padding: torem(12) 0;

    /deep/ .van-picker__toolbar {
      button {
        font-size: torem(14);
        color: #7f8490;
      }

      .van-picker__title {
        font-size: torem(14);
        color: #000922;
      }
    }
  }
}

.confirm-information {
  width: 100%;
  height: auto;
  background-color: #F9F9F9;
  border-radius: torem(8);
  padding: torem(24) torem(16);

  h2.title {
    font-size: torem(14);
    color: #000922;
    margin-bottom: torem(16);
  }

  ul li {
    list-style: none;
    font-size: torem(14);
    color: #40475A;
    line-height: 1.5;
    margin-bottom: torem(4);
    white-space: break-spaces;
  }
}

</style>


// WEBPACK FOOTER //
// src/compontents/freeZone/createSymbol/firstStep.vue